var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.contactData).length > 0)?_c('div',{staticClass:"map"},[_c('i',{staticClass:"fas fa-spinner fa-2x fa-spin"}),_c('iframe',{attrs:{"src":_vm.src}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }